import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cscTable = {
  cellPaddingBlock: css`var(--csc-table-cell-padding-y, ${csSpacing.spacing05})`,
  cellPaddingInline: css`var(--csc-table-cell-padding-x, ${csSpacing.spacing05})`,
  cellRowGap: css`var(--csc-table-cell-row-gap, ${csSpacing.spacing04})`,
  rowBackgroundColorPrimary: css`var(--csc-table-row-background-color-primary, ${csColorBackground.primary})`,
  rowBackgroundColorSecondary: css`var(--csc-table-row-background-color-secondary, ${csColorBackground.primary})`,
}

export const tableStyle: CSSResult = css`
  :host {
    display: grid;
    width: 100%;
    grid-auto-rows: minmax(40px, auto);
  }

  :host([variant="line"]) {
    border: 1px solid ${csColorBorder.light};
  }

  :host([variant="secondary"]) {
    border: 1px solid ${csColorBorder.light};
    border-radius: ${csBorder.radiusMinimal};
    overflow: hidden;
  }

  csc-table-header-cell {
    align-content: center;

    &[variant="primary"],
    &[variant="secondary"],
    &[variant="line"] {
      background-color: ${csColorBackground.secondary};
      border-bottom: 1px solid ${csColorBorder.light};
    }

    &[variant="secondary"],
    &[variant="line"] {
      --cs-font-body-s-font-weight: 700;
    }
  }

  csc-table-header-cell[truncate] {
    overflow: hidden;
    min-width: 0;
  }

  csc-table-header-cell[truncate] cse-text {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    --cse-text-overflow: hidden;
    --cse-text-white-space: nowrap;
    --cse-text-text-overflow: ellipsis;
  }

  csc-table-header-cell cse-text {
    padding: ${cscTable.cellPaddingBlock} ${cscTable.cellPaddingInline};
  }

  csc-table-cell {
    display: grid;
    background-color: ${cscTable.rowBackgroundColorPrimary};
    padding: ${cscTable.cellPaddingBlock} ${cscTable.cellPaddingInline};
    row-gap: ${cscTable.cellRowGap};
    align-content: center;

    &[variant="secondary"],
    &[variant="line"] {
      &:not(.last-row) {
        border-bottom: 1px solid ${csColorBorder.light};
      }
    }
  }

  csc-table-cell.secondary-row {
    background-color: ${cscTable.rowBackgroundColorSecondary};
  }

  svg.loading {
    display: block;
    vertical-align: middle;

    rect {
      fill: #e0e0e0;
    }
  }

  .header-wrapper, .row-wrapper {
    display: contents;
  }

  .cell-actions {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: flex-end;
    gap: ${csSpacing.spacing05};
  }

  .cell-actions__primary {
    flex: 1 1 200px;
    min-width: 0;
  }

  .cell-actions__secondary {
    flex-shrink: 0;
    --cse-icon-button-size: var(--cse-button-height);
  }
`
